module.exports = __webpack_public_path__ + "static/media/brooklynBridge.66467e84.jpg";